<template>
  <div class="layout-complete">
    <AppHeader />
    <div class="flex-grow-1 d-flex flex-row">
      <AwlSidenav v-if="isLogged" class="d-none d-lg-block" :links="links" />
      <router-view class="page flex-grow-1" />
    </div>
    <AppFooter />
    <MobileSidebar class="sidebar mobile-sidebar" :links="links" />
    <ConfirmBox />
  </div>
</template>

<script>

import rolesMixin from '../../../mixins/roles';

export default {
  name: 'layout-complete-layout',
  mixins: [rolesMixin],
  components: {
    AppHeader: () => import('./Header'),
    AppFooter: () => import('./Footer'),
    AwlSidenav: () => import('../../../libs/Sidebar/components/AwlSidenav'),
    MobileSidebar: () => import('./MobileSidebar'),
    ConfirmBox: () => import(/* webpackChunkName: "component-confirm-modal" */ './ConfirmBox'),
  },
  computed: {
    links () {
      return [
        { name: 'Dashboard', to: { name: 'dashboard' }, active: this.$route.path.startsWith('/dashboard') || this.$route.path.startsWith('/cart') || this.$route.path.startsWith('/profile') || (this.$route.path.startsWith('/coaches') && this.isParent) },
        { name: 'Golf Club', to: { name: 'clubs.list' }, active: this.$route.path.startsWith('/clubs'), hidden: !this.isAdmin && !this.isParent },
        { name: 'Golf Club', to: { name: 'clubs.list-mine' }, active: this.$route.path.startsWith('/clubs'), hidden: !this.isCoach },
        { name: 'Coaches', to: { name: 'coaches.list' }, active: this.$route.path.startsWith('/coaches'), hidden: !this.isAdmin },
        { name: 'Genitori', to: { name: 'parents.list' }, active: this.$route.path.startsWith('/parents'), hidden: !this.isAdmin },
        { name: 'Giocatori', to: { name: 'players.list' }, active: this.$route.path.startsWith('/players'), hidden: !this.isAdmin && !this.isParent },
        { name: 'Eventi', to: { name: 'competitions.list' }, active: this.$route.path.startsWith('/competitions'), hidden: !this.isAdmin && !this.isCoach },
        { name: 'Calendario eventi', to: { name: 'competitions.regions' }, active: this.$route.path.startsWith('/competitions'), hidden: !this.isParent },
        { name: 'Pagamenti', to: { name: 'payments.list' }, active: this.$route.path.startsWith('/payments'), hidden: !this.isAdmin && !this.isParent },
        { name: 'Assistenza', to: { name: 'help' }, hidden: !this.isParent },
        { name: 'Impostazioni', to: { name: 'settings' }, hidden: !this.isAdmin },
      ];
    },
  },
};

</script>

<style lang="scss">

$sidebar-border-right-color: #1C2023 !default;
$sidebar-size-header-height-mobile: 82px !default;

.main-header {
  height: $sidebar-size-header-height-mobile;
}

.sidebar {
  min-width: 200px;
  border-right: 1px solid $sidebar-border-right-color;
}

.page {
  padding: 10px 25px;
  max-width: 100%;
}

.sidebar {
  @include media-breakpoint-up("lg") {
    display: none !important;
  }
}

</style>
